import {type PaletteOptions} from '@mui/material/styles';

export const themePaletteDark: PaletteOptions = {
  text: {primary: '#dfdfdf', secondary: '#afafaf'},
  action: {active: '#aaa'},
  background: {paper: '#222', default: '#282828'},
};
